import React, { useCallback, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';

import { RootState } from 'store';

import Loader from 'components/Loader';
import { Desktop, Mobile } from 'components/Responsive';
import ScreenHeader from 'components/ScreenHeader';
import useStoreTranslation from 'hooks/useStoreTranslation';
import { getCompanyLineCredit } from 'services/paymentMethodService';

import NavigationList from './NavigationList';
import { Container, Content, Subtitle } from './styles';
import SubMenuHeader from './SubMenuHeader';
import useUserAccount from 'hooks/useUserAccount';

export interface MenuItem {
  name: string;
  show: boolean;
  onClick: () => void;
}

const SettingsSubMenu = () => {
  const history = useHistory();
  const { t } = useStoreTranslation();
  const accountResult = useSelector((state: RootState) => state.user.accountResult);
  const [loading, setLoading] = useState(true);
  const [hasLineCredit, setHasLineCredit] = useState(false);
  const user = useUserAccount();

  const renderHeader = () => <SubMenuHeader onClose={history.goBack} title={t('userMenu.administrator')} />;

  const companyId = accountResult?.companyId;
  const menuList: Array<MenuItem> = [];

  menuList.push({
    name: t('billing.profile.title'),
    onClick: () => history.push('/corporate/companyBilling'),
    show: true,
  });

  const checkCreditLine = useCallback(async () => {
    if (companyId) {
      const {
        data: { lineOfCreditAvailable },
      } = await getCompanyLineCredit(companyId);
      if (lineOfCreditAvailable) setHasLineCredit(true);
      setLoading(false);
    }
  }, [companyId]);

  useEffect(() => {
    checkCreditLine();
  }, [checkCreditLine, companyId]);

  const hasPaymentException =
    (user.hasAirPaymentException || user.hasHotelPaymentException || user.hasVehiclePaymentException) && !user.hasCreditCardByUserException;

  if ((!hasLineCredit && !user.creditCardByUser) || hasPaymentException) {
    menuList.push({
      name: t('companySettings.paymentMethods'),
      onClick: () => history.push('/corporate/paymentMethods'),
      show: true,
    });
  }
  menuList.push({
    name: t('companySettings.airlineException'),
    onClick: () => history.push('/corporate/airlineException'),
    show: true,
  });

  return loading ? (
    <Loader fullScreen />
  ) : (
    <Container>
      <Desktop>
        <ScreenHeader title={t('companySettings.title')} subtitle={t('companySettings.detail')} />
      </Desktop>

      <Mobile>
        {renderHeader()}
        <Subtitle>{t('userMenu.administrator')}</Subtitle>
      </Mobile>

      <Content>
        <NavigationList list={menuList} />
      </Content>
    </Container>
  );
};

export default SettingsSubMenu;
